import axios from "axios";
//
import ApiUrls from "./ApiUrls";

const ApiFunc = {
  readLxtData: (
    apiStr,
    timeout = 5000,
    debug = false,
    isCancelled = false,
    _locale
  ) => {
    // lang
    const curLocale = _locale || ApiUrls.getLocale();
    const api = apiStr.replace("{locale}", curLocale);
    // console.log("readLxtData", api);

    // timeout
    axios.defaults.timeout = timeout;
    // console.log("readLxtData timeout", timeout);

    try {
      // abort if it tyr too long
      // const controller = new AbortController();
      // const signal = controller.signal;
      // // to stop fetch if timeout
      // if (isCancelled) {
      //     controller.abort();
      // } else {
      //     setTimeout(() => controller.abort(), timeout);
      // }

      // // debug
      // if (debug) {
      //   console.log(api);
      //   console.log("Authorization axios", axios.defaults.headers);
      // }

      // fetch api
      return axios
        .get(api)
        .then((response) => ({
          data: response?.data?.data || [],
          durationSS: response?.durationSS,
        }))
        .catch((err) => {
          // handle AbortController event and return error message
          if (err.name === "AbortError") {
            // console.error("api:hkbdb:fetch:get:aborted:cancle:or:timeout");
            return { data: [], error: err.message };
          }
          // handle other error event and return error message

          // console.error("api:lxt:fetch:get:error:", err.message);
          return { data: [], error: err.message };
        });
    } catch (err) {
      // console.error("api:lxt:fetch:catch:error: ", err.message);
      return { data: [], error: err.message };
    }
  },
};

export default ApiFunc;
